// extracted by mini-css-extract-plugin
export default {"header":"App_header__YKeOP","link":"App_link__OAkob","button":"App_button__8UZ-J","subLink":"App_subLink__NfqdC","dropdownFooter":"App_dropdownFooter__M+NuD"};